import React from 'react';

type UnityProps = React.SVGProps<SVGSVGElement>;

const Unity: React.FC<UnityProps> = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 540"
      className={className}
      fill="currentColor"
      {...props}
    >
      <path d="M 488.50575,386.2069 V 128.73563 L 265.51724,0 v 98.850575 l 87.35632,50.574715 c 3.44828,2.29885 3.44828,6.89655 0,8.04597 l -103.44827,59.77012 c -3.44828,2.29885 -6.89655,1.14942 -9.1954,0 L 136.78161,157.47126 c -3.44828,-1.14942 -3.44828,-6.89655 0,-8.04597 L 224.13793,98.850575 V 0 L 0,128.73563 v 257.47127 -1.14943 1.14943 L 85.057471,336.78161 V 235.63218 c 0,-3.44827 4.597701,-5.74712 6.896552,-4.5977 L 195.4023,290.8046 c 3.44827,2.29885 4.5977,4.5977 4.5977,8.04597 V 418.3908 c 0,3.44828 -4.5977,5.74713 -6.89655,4.59771 L 105.74713,372.41379 20.689655,421.83908 243.67816,551.72414 466.66667,422.98851 381.6092,373.56322 294.25287,424.13793 c -3.44827,2.29885 -6.89655,0 -6.89655,-4.5977 V 300 c 0,-3.44828 2.29885,-6.89655 4.5977,-8.04598 L 395.4023,232.18391 c 3.44827,-2.29885 6.89655,0 6.89655,4.5977 v 101.14942 z" />
      <path d="M 243.67816,551.72414 466.66667,422.98851 381.6092,373.56322 294.25287,424.13793 c -3.44827,2.29885 -6.89655,0 -6.89655,-4.5977 V 300 c 0,-3.44828 2.29885,-6.89655 4.5977,-8.04598 L 395.4023,232.18391 c 3.44827,-2.29885 6.89655,0 6.89655,4.5977 v 101.14942 l 85.05747,49.42529 V 128.73563 L 243.67816,270.11494 Z" />
    </svg>
  );
};

export default Unity;
